/**
 * Typed accessor for the runtime env injected by /assets/env.js.
 *
 * The env.js script sets window.__ENV__ before Stencil boots.
 * Each config module (api, oauth2) reads from here with its own defaults.
 */

interface RuntimeEnv {
  API_BASE_URL?: string;
  OAUTH2_AUTHORIZATION_ENDPOINT?: string;
  OAUTH2_LOGOUT_ENDPOINT?: string;
  OAUTH2_CLIENT_ID?: string;
  OAUTH2_SCOPES?: string;
}

declare global {
  interface Window {
    __ENV__?: RuntimeEnv;
  }
}

export function getEnv(): RuntimeEnv {
  return window.__ENV__ ?? {};
}
